<template>
  <div class="ctrl-login">
    <div class="wrap1100">
      <CtrlGroupMember />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CtrlGroupMember from "@/components/Ctrl/GroupMember.vue";
export default {
  name: "ctrl-login",
  components: {
    CtrlGroupMember,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["rootUrl"]),
  },
};
</script>

<style lang="scss" scoped>
</style>
